import Vue from "vue";
import Vuex from "vuex";

import axios from "axios";
import * as R from "ramda";
import router from "@/router";

import senStore from "./modules/senStore";
import wriStore from "./modules/wriStore";
import intentStore from "./modules/intentStore";
import chapterStore from "./modules/chapterStore";

import * as _ from "lodash";

Vue.use(Vuex);

import contentmenu from "v-contextmenu";
import "v-contextmenu/dist/index.css";

Vue.use(contentmenu);

const SERVER_URL = `${process.env.VUE_APP_SERVER_URL}`;

export default new Vuex.Store({
  state: {
    r: "Hello {10}",
    appendS: [],
    auth_user: "",
    auth_grade: 0,
    mode: "preview", // form , preview
    srhtext: "",
    count: 0,
    currentPage: 1,
    debug: "디버그 메세지",
    book_id: "",
    totalQcountByID: 0,

    tabIndex: 1, // 개발문항, 그룹문항 탭 index

    previews_questions: [],

    booklist_field: ["NO", "ISBN", "교재명", "저작자", "유닛관리", "문제은행"],
    intent_field: ["아이디", "대분류", "중분류", "소분류", "사용여부", "관리"],
    booklist: [], // NOTUSED
    questionlist_field: [
      {
        key: "문제순서",
        label: "문제순서",
        thClass: "qf_cls1",
        tdClass: "qf_cls1",
      },
      {
        key: "문제코드",
        label: "문제코드",
        thClass: "qf_cls2",
        tdClass: "qf_cls2",
      },
      {
        key: "pay",
        label: "유료/무료",
        thClass: "qf_cls3",
        tdClass: "qf_cls3",
      },
    ], //NOTUSED
    questionlist: [], //NOTUSED

    formvalid: false,
    valid: {
      chapter: "",
      unit: "",
      qserial: "",
      statement: "",
      statement2: "",
      statement3: "",
      statement4: "",

      title: "",
      level: "",
      senlevel: "",
      ans1: "", //qtype2 에서 쓰임
      intent1: "", //qtype2 에서 쓰임,
      qtype1: "",
      qtype2: "",
      qtype3: "",
      qtype4: "",
      qtype5: "",
      qtype7: "",
      qtype8: "",

      qtype1_nocount: "",
      qtype2_nocount: "",
      qtype3_nocount: "",
      qtype4_nocount: "",
      qtype5_nocount: "",
      qtype7_nocount: "",
      qtype8_nocount: "",
    },

    subtitle: "",
    bookform: {
      isbn: "",
      owner: "",
      title: "",
      region: "",
      target: [],
      pubdate: "",
      coverimg: "",
      id: "",
      meta1: null,
      meta2: null,
      meta3: null,
    },
    question_count: 0,

    questionmeta: {
      book_id: "",
      qcode: "",
      chapter: "", //챕터
      unit: "", // 유닛
      qserial: "", // 문제순서.
      std_type: "1", //  학습유형
      statement: "", //지시문(직독직해)
      statement2: "", // 스크램블
      statement3: "", // 영작
      statement4: "", // 지시문(구조분석)
      id: "",
      jimun: "", // 지문
      jimun_imsi: null, // 지문

      plain_jimun: "",
      plain_jimun_imsi: null,

      qcomment: "", // 해설
      qcomment_imsi: "", // 해설
      translate: "", // 해석
      translate_imsi: "", // 해석
      grp_type: "2", // 문제 묶음 방식 1 : 개발문항 , 2: 그룹 문항
      owner: "",
      jimunwords: [{ id: 1, word: "", comment: "" }],

      plain_jimun_subject: null,
      plain_jimun_level: null,
      jimun_word_count: 0,
      plain_jimun_word_count: 0,
      plain_jimun_idf: null,
    },

    qforms: [], // 그룹문항인경우 문항 리스트
    questionform: {
      id: "",
      book_id: "",
      meta_id: "",

      q_type: "1", //문제유형   1:서답형 , 2:선택형 , 3:선다형 4:어순배열
      q_type_sub: "1", // 선다형의 경우   1:단순선다 , 2:연결형,  3:교정형 , 4:교정신규형()
      title: "", // 문제명
      title_imsi: "", // 문제명
      qstatement: "", //  문항별 지시문

      ans1: "", // 정답제목
      ans1_text: "", // 정답
      ans1_sub: "",
      intent1: "", // 출제포인트

      ans2: "", // 정답제목
      ans2_text: "", // 정답
      ans2_sub: "",
      intent2: "", // 출제포인트

      ans3: "", // 정답제목
      ans3_text: "", // 정답
      ans3_sub: "",
      intent3: "", // 출제포인트

      ans4: "", // 정답제목
      ans4_text: "", // 정답
      ans4_sub: "",
      intent4: "", // 출제포인트

      ans5: "", // 정답제목
      ans5_text: "", // 정답
      ans5_sub: "",
      intent5: "", // 출제포인트

      ans6: "", // 정답제목
      ans6_text: "", // 정답
      ans6_sub: "",
      intent6: "", // 출제포인트

      ans7: "", // 정답제목
      ans7_text: "", // 정답
      ans7_sub: "",
      intent7: "", // 출제포인트

      ans8: "", // 정답제목
      ans8_text: "", // 정답
      ans8_sub: "",
      intent8: "", // 출제포인트

      ans9: "", // 정답제목
      ans9_text: "", // 정답
      ans9_sub: "",
      intent9: "", // 출제포인트

      ans10: "", // 정답제목
      ans10_text: "", // 정답
      ans10_sub: "",
      intent10: "", // 출제포인트

      image: "", // 이미지
      videos: [
        {
          id: "video_1",
          link: "",
          video_from: "",
          video_to: "",
          video_use: true,
        },
      ], // 동영상리스트
      sound: "", // 사운드
      level: [], //난이도
      senlevel: "",
      word_level: "",
      prevtest_info: "",
      point: null,
      qcomment: "", // 해설 (독해용)
      qcomment_imsi: "", // 해설(독해요)
    },

    qtype_2_intents: [],

    std_type_options: [
      { text: "구문/영작훈련", value: "1", disabled: false },
      { text: "문풀훈련", value: "2", disabled: false },
      { text: "독해모의", value: "3", disabled: false },
    ],

    q_type_options: [
      { text: "서답형", value: "1" },
      { text: "선택형", value: "2", disabled: false },
      { text: "선다형", value: "3", disabled: false },
      { text: "어순배열", value: "4", disabled: false },
      { text: "보기선택", value: "5", disabled: false },
      { text: "밑줄긋기", value: "6", disabled: false },
    ],

    q_type_reading_options: [
      { text: "객관식", value: "7" },
      { text: "주관식", value: "8", disabled: false },
    ],

    q_type_sub_options: [
      { text: "단순선다", value: "1" },
      { text: "연결형", value: "2", disabled: false },
      { text: "교정형", value: "3", disabled: false },
      { text: "교정형(지문내)", value: "4", disabled: false },
    ],

    qtype1_answers_old: [{ id: "1", ansTitle: "", answer: "", intent: "" }],
    qtype1_answers: [],

    qtype2_picks_old: [{ id: "1", text: "" }],
    qtype2_picks: [],

    qtype3_picks_old: [{ id: "1", text: "", answer: "", sub: false }],

    qtype3_picks: [],

    qtype5_picks: [],
    qtype6_picks: [],
    qtype7_picks: [],
    qtype8_picks: [],
    intent_options2: [], //NOTUSED

    intent_options: [],

    intent_value: { name: "Vue.js", language: "JavaScript" },
    lvl_options: [
      { text: "초저", value: "1" },
      { text: "초고", value: "2" },

      { text: "중1", value: "3", disabled: false },
      { text: "중2", value: "4", disabled: false },
      { text: "중3", value: "5", disabled: false },

      { text: "고1", value: "6", disabled: false },
      { text: "고2", value: "7", disabled: false },
      { text: "고3", value: "8", disabled: false },

      { text: "공무원 초급", value: "9", disabled: false },
      { text: "공무원 실전", value: "10", disabled: false },
    ],

    word_level_options: [
      { text: "고난도", value: "0" },
      { text: "고등 심화/수능", value: "1" },
      { text: "중등 심화~고등", value: "2" },
      { text: "초등~중등 기본", value: "3" },
    ],
    jimun_subject_options: [
      { text: "소재", value: null },
      { text: "인물", value: 1 },
      { text: "일화", value: 2 },
      { text: "철학", value: 3 },
      { text: "종교", value: 4 },
      { text: "역사", value: 5 },
      { text: "문화_풍습", value: 6 },
      { text: "지리", value: 7 },
      { text: "환경_자원", value: 8 },
      { text: "과학(물리_화학_생명과학_지구과학)", value: 9 },

      { text: "예술", value: 10 },
      // { text: "미술", value: 11 },
      // { text: "영화", value: 12 },
      // { text: "무용", value: 13 },
      // { text: "사진", value: 14 },

      { text: "건축", value: 15 },
      { text: "교육", value: 16 },
      { text: "언어(문학_문화)", value: 17 },
      { text: "IT(컴퓨터_인터넷_정보_미디어_교통)", value: 18 },
      { text: "심리", value: 19 },
      { text: "정치", value: 20 },
      { text: "경제", value: 21 },
      { text: "사회", value: 22 },
      { text: "법", value: 23 },
      { text: "의학(건강_영양_식품)", value: 24 },
      { text: "직장(복지, 업무)", value: 25 },
      { text: "스포츠", value: 27 },
      { text: "기타", value: 26 },
    ],
    jimun_level_options: [
      { text: "난이도", value: null },
      { text: "Level1", value: "1" },
      { text: "Level2", value: "2" },
      { text: "Level3", value: "3" },
      { text: "Level4", value: "4" },
      { text: "Level5", value: "5" },
    ],

    question_point_options: [
      { text: "배점", value: null },
      { text: "1", value: 1 },
      { text: "2", value: 2 },
      { text: "3", value: 3 },
      { text: "4", value: 4 },
      { text: "5", value: 5 },
    ],
  },
  mutations: {
    updateSrhtext(state, val) {
      state.srhtext = val;
    },

    updateCount(state, val) {
      state.count = val;
    },
    updateCurrentPage(state, val) {
      state.currentPage = val;
    },

    updateQuestionMeta(state, val) {
      // val.jimun_imsi = val.jimun;
      // val.translate_imsi = val.translate;
      // val.qcomment_imsi = val.qcomment;

      state.questionmeta = val;
      state.questionmeta.jimun_imsi = val.jimun;
      state.questionmeta.translate_imsi = val.translate;
      state.questionmeta.qcomment_imsi = val.qcomment;

      state.questionmeta.plain_jimun_imsi = val.plain_jimun;
    },

    resetvalid(state) {
      let valid = {
        chapter: "",
        unit: "",
        qserial: "",
        statement: "",
        statement2: "",
        statement3: "",
        statement4: "",
        title: "",
        level: "",
        senlevel: "",
        ans1: "", //qtype2 에서 쓰임
        intent1: "", //qtype2 에서 쓰임
        qtype1: "",
        qtype2: "",
        qtype3: "",
        qtype4: "",
        qtype5: "",
        qtype7: "",
        qtype8: "",

        qtype1_nocount: "",
        qtype2_nocount: "",
        qtype3_nocount: "",
        qtype4_nocount: "",
        qtype5_nocount: "",
        qtype7_nocount: "",
        qtype8_nocount: "",
      };

      state.valid = valid;
    },

    updatemetavalid(state) {
      let isinvalid = false;

      let chapter = state.questionmeta.chapter;
      if (chapter === "") {
        state.valid.chapter = "invalid";
        isinvalid = true;
      } else {
        state.valid.chapter = "";
      }

      let unit = state.questionmeta.unit;
      if (unit === "") {
        state.valid.unit = "invalid";
        isinvalid = true;
      } else {
        state.valid.unit = "";
      }

      let qserial = state.questionmeta.qserial;

      if (qserial === 0 || qserial === "") {
        state.valid.qserial = "invalid";
        isinvalid = true;
      } else {
        state.valid.qserial = "";
      }

      let statement = state.questionmeta.statement;
      if (statement === "") {
        state.valid.statement = "invalid";
        isinvalid = true;
      } else {
        state.valid.statement = "";
      }

      state.formvalid = !isinvalid;
    },

    Updateformvalid(state) {
      let isinvalid = false;

      let chapter = state.questionmeta.chapter;
      if (chapter === "") {
        state.valid.chapter = "invalid";
        isinvalid = true;
      } else {
        state.valid.chapter = "";
      }

      let unit = state.questionmeta.unit;
      if (unit === "") {
        state.valid.unit = "invalid";
        isinvalid = true;
      } else {
        state.valid.unit = "";
      }

      let qserial = state.questionmeta.qserial;

      if (qserial === 0 || qserial === "") {
        state.valid.qserial = "invalid";
        isinvalid = true;
      } else {
        state.valid.qserial = "";
      }

      let statement = state.questionmeta.statement;
      if (statement === "") {
        state.valid.statement = "invalid";
        isinvalid = true;
      } else {
        state.valid.statement = "";
      }

      /*
      let title = state.questionform.title;
      if (title === "") {
        state.valid.title = "invalid";
        isinvalid = true;
      } else {
        state.valid.title = "";
      }
      */

      // if (state.questionmeta.std_type == "2") {
      let level = state.questionform.level;

      if (level.length === 0) {
        state.valid.level = "invalid";
        isinvalid = true;
      } else {
        state.valid.level = "";
      }

      // } else if (state.questionmeta.std_type == "1") {
      // let senlevel = state.questionform.senlevel;
      // if (senlevel == "") {
      //   state.valid.senlevel = "invalid";
      //   isinvalid = true;
      // } else {
      //   state.valid.senlevel = "";
      // }
      // }

      if (state.questionmeta.std_type == "1") {
        if (state.senStore.shuffle_answers.length > 0) {
          let statement2 = state.questionmeta.statement2;
          if (statement2 === "") {
            state.valid.statement2 = "invalid";
            isinvalid = true;
          } else {
            state.valid.statement2 = "";
          }
        } else {
          state.valid.statement2 = "";
        }
      }

      if (state.questionform.q_type === "1-old") {
        // 타입 1의 경우  intent 및  ans{x}_text 는 체크가 필요함.
        let i = 1;

        if (state.qtype1_answers.length == 0) {
          state.valid.qtype1_nocount = "invalid";
          isinvalid = true;
        } else {
          state.valid.qtype1_nocount = "";
        }

        let invalids = R.filter((item) => {
          return item.answer === "";
        }, state.qtype1_answers);

        if (invalids.length > 0) {
          state.valid.qtype1 = "invalid";
          isinvalid = true;
        } else {
          state.valid.qtype1 = "";
        }

        let intent1 = state.questionform.intent1;
        if (intent1 === "") {
          // 출제 포인트 체크

          state.valid.intent1 = "invalid";
          isinvalid = true;
        } else {
          state.valid.intent1 = "";
        }
      } else if (
        state.questionform.q_type === "1" &&
        state.questionmeta.std_type == "2"
      ) {
        if (state.qtype1_answers.length == 0) {
          state.valid.qtype1_nocount = "invalid";
          isinvalid = true;
        } else {
          state.valid.qtype1_nocount = "";
        }

        let filterIndexed = R.addIndex(R.filter);
        let invalids = filterIndexed((item, idx) => {
          return state.questionform[`ans${idx + 1}_text`] == "";
        }, state.qtype1_answers);

        if (invalids.length > 0) {
          state.valid.qtype1 = "invalid";
          isinvalid = true;
        } else {
          state.valid.qtype1 = "";
        }

        let intent1 = state.questionform.intent1;
        if (intent1 === "") {
          // 출제 포인트 체크

          state.valid.intent1 = "invalid";
          isinvalid = true;
        } else {
          state.valid.intent1 = "";
        }
      }
      if (state.questionform.q_type === "2") {
        //선택형의 경우

        if (state.qtype2_picks.length == 0) {
          state.valid.qtype2_nocount = "invalid";
          // state.valid.qtype1 = "invalid";
          isinvalid = true;
        } else {
          state.valid.qtype2_nocount = "";
        }

        let filterIndexed = R.addIndex(R.filter);
        let invalids = filterIndexed((item, idx) => {
          return state.questionform[`ans${idx + 1}_text`] == "";
        }, state.qtype2_picks);

        if (invalids.length > 0) {
          state.valid.qtype2 = "invalid";
          isinvalid = true;
        } else {
          state.valid.qtype2 = "";
        }

        //선택지 체크
        // let invalids = R.filter(item => {
        //   return item.text === "";
        // }, state.qtype2_picks);

        // if (invalids.length > 0) {
        //   state.valid.qtype2 = "invalid";
        //   isinvalid = true;
        // } else {
        //   state.valid.qtype2 = "";
        // }

        let intent1 = state.questionform.intent1;
        if (intent1 === "") {
          // 출제 포인트 체크

          state.valid.intent1 = "invalid";
          isinvalid = true;
        } else {
          state.valid.intent1 = "";
        }
      }
      if (state.questionform.q_type === "3") {
        //선택형의 경우

        if (state.qtype3_picks.length == 0) {
          state.valid.qtype3_nocount = "invalid";
          // state.valid.qtype1 = "invalid";
          isinvalid = true;
        } else {
          state.valid.qtype3_nocount = "";
        }

        let filterIndexed = R.addIndex(R.filter);
        let invalids = filterIndexed((item, idx) => {
          return state.questionform[`ans${idx + 1}`] == "";
        }, state.qtype3_picks);

        if (invalids.length > 0) {
          state.valid.qtype3 = "invalid";
          isinvalid = true;
        } else {
          state.valid.qtype3 = "";
        }

        let intent1 = state.questionform.intent1;
        if (intent1 === "") {
          // 출제 포인트 체크

          state.valid.intent1 = "invalid";
          isinvalid = true;
        } else {
          state.valid.intent1 = "";
        }
      }
      if (state.questionform.q_type === "4") {
        //선택형의 경우

        let ans1 = state.questionform.ans1;
        if (ans1 === "") {
          //정답으로 쓰임

          state.valid.ans1 = "invalid";
          isinvalid = true;
        } else {
          state.valid.ans1 = "";
        }

        let intent1 = state.questionform.intent1;
        if (intent1 === "") {
          // 출제 포이늩 체크

          state.valid.intent1 = "invalid";
          isinvalid = true;
        } else {
          state.valid.intent1 = "";
        }
      }

      state.formvalid = !isinvalid;
    },

    udpateTabindex(state, val) {
      state.tabIndex = val;
    },
    updateDebug(state, msg) {
      state.debug = msg;
    },
    updateBookID(state, book_id) {
      state.book_id = book_id;
      state.questionmeta.book_id = book_id;
      state.questionform.book_id = book_id;
    },
    //교재 관련 시작 ----------------------------------------
    updateIsbn(state, val) {
      state.bookform.isbn = val;
    },
    updateOwner(state, val) {
      state.bookform.owner = val;
    },
    updateTitle(state, val) {
      state.bookform.title = val;
    },
    updateRegion(state, val) {
      state.bookform.region = val;
    },
    updateTarget(state, val) {
      state.bookform.target = val;
      // state.bookform.target.append(val)
    },
    updatePubdate(state, val) {
      state.bookform.pubdate = val;
    },
    updateCoverimg(state, val) {
      state.bookform.coverimg = val;
    },

    updateMeta1(state, val) {
      state.bookform.meta1 = val;
    },

    updateMeta2(state, val) {
      state.bookform.meta2 = val;
    },
    updateMeta3(state, val) {
      state.bookform.meta3 = val;
    },

    resetBookForm(state) {
      state.bookform.id = "";
      state.bookform.isbn = "";
      state.bookform.owner = "";
      state.bookform.title = "";
      state.bookform.region = "";
      state.bookform.target = "";
      state.bookform.pubdate = "";
      state.bookform.coverimg = "";
      state.bookform.meta1 = null;
      state.bookform.meta2 = null;
      state.bookform.meta3 = null;
    },

    resetQuestionOnly(state) {
      state.questionform.prevtest_info = "";
      state.questionform.id = "";
      // state.questionform.meta_id = "";
      state.questionform.title = ""; // 문제명
      state.questionform.qstatement = ""; // 문항별 지시문

      state.questionform.ans1 = ""; // 정답제목
      state.questionform.ans1_text = ""; // 정답
      state.questionform.ans1_sub = ""; // 정답
      state.questionform.intent1 = ""; // 출제포인트

      state.questionform.ans2 = ""; // 정답제목
      state.questionform.ans2_text = ""; // 정답
      state.questionform.ans2_sub = ""; // 정답
      state.questionform.intent2 = ""; // 출제포인트

      state.questionform.ans3 = ""; // 정답제목
      state.questionform.ans3_text = ""; // 정답
      state.questionform.ans3_sub = ""; // 정답
      state.questionform.intent3 = ""; // 출제포인트

      state.questionform.ans4 = ""; // 정답제목
      state.questionform.ans4_text = ""; // 정답
      state.questionform.ans4_sub = ""; // 정답
      state.questionform.intent4 = ""; // 출제포인트

      state.questionform.ans5 = ""; // 정답제목
      state.questionform.ans5_text = ""; // 정답
      state.questionform.ans5_sub = ""; // 정답
      state.questionform.intent5 = ""; // 출제포인트

      state.questionform.ans6 = ""; // 정답제목
      state.questionform.ans6_text = ""; // 정답
      state.questionform.ans6_sub = ""; // 정답
      state.questionform.intent6 = ""; // 출제포인트

      state.questionform.ans7 = ""; // 정답제목
      state.questionform.ans7_text = ""; // 정답
      state.questionform.ans7_sub = ""; // 정답
      state.questionform.intent7 = ""; // 출제포인트

      state.questionform.ans8 = ""; // 정답제목
      state.questionform.ans8_text = ""; // 정답
      state.questionform.ans8_sub = ""; // 정답
      state.questionform.intent8 = ""; // 출제포인트

      state.questionform.ans9 = ""; // 정답제목
      state.questionform.ans9_text = ""; // 정답
      state.questionform.ans9_sub = ""; // 정답
      state.questionform.intent9 = ""; // 출제포인트

      state.questionform.ans10 = ""; // 정답제목
      state.questionform.ans10_text = ""; // 정답
      state.questionform.ans10_sub = ""; // 정답
      state.questionform.intent10 = ""; // 출제포인트

      state.questionform.image = ""; // 이미지
      state.questionform.videos = [
        {
          id: "video_1",
          link: "",
          video_from: "",
          video_to: "",
          video_use: true,
        },
      ]; // 동영상리스트
      state.questionform.sound = ""; // 사운드
      state.questionform.level = []; //난이도
      state.questionform.senlevel = ""; //난이도
      state.questionform.word_level = "";
      state.questionform.point = null;

      // state.qtype1_answers = [
      //   { id: "1", ansTitle: "", answer: "", intent: "" },
      // ];

      state.qtype1_answers = [];

      // state.qtype2_picks = [{ id: "1", text: "" },];
      state.qtype2_picks = [];

      // state.qtype3_picks = [{ id: "1", text: "", answer: "", sub: false },];
      state.qtype3_picks = [];

      state.qtype5_picks = [];

      state.qtype7_picks = [];
      state.qtype8_picks = [];

      state.questionform.qcomment = null;
      state.questionform.qcomment_imsi = null;
    },

    resetQuestionForm(state) {
      state.questionform.prevtest_info = "";
      state.questionform.id = "";
      // state.questionform.book_id = "";
      state.questionform.meta_id = "";
      // state.questionform.q_type = "1"; //문제유형  --> 좌측 리스트에서만 삭제
      state.questionform.q_type_sub = "1"; //문제유형
      state.questionform.title = ""; // 문제명
      state.questionform.title_imsi = ""; // 문제명
      state.questionform.qstatement = ""; // 문항별 지시문

      state.questionform.ans1 = ""; // 정답제목
      state.questionform.ans1_text = ""; // 정답
      state.questionform.ans1_sub = ""; // 정답
      state.questionform.intent1 = ""; // 출제포인트

      state.questionform.ans2 = ""; // 정답제목
      state.questionform.ans2_text = ""; // 정답
      state.questionform.ans2_sub = ""; // 정답
      state.questionform.intent2 = ""; // 출제포인트

      state.questionform.ans3 = ""; // 정답제목
      state.questionform.ans3_text = ""; // 정답
      state.questionform.ans3_sub = ""; // 정답
      state.questionform.intent3 = ""; // 출제포인트

      state.questionform.ans4 = ""; // 정답제목
      state.questionform.ans4_text = ""; // 정답
      state.questionform.ans4_sub = ""; // 정답
      state.questionform.intent4 = ""; // 출제포인트

      state.questionform.ans5 = ""; // 정답제목
      state.questionform.ans5_text = ""; // 정답
      state.questionform.ans5_sub = ""; // 정답
      state.questionform.intent5 = ""; // 출제포인트

      state.questionform.ans6 = ""; // 정답제목
      state.questionform.ans6_text = ""; // 정답
      state.questionform.ans6_sub = ""; // 정답

      state.questionform.ans7 = ""; // 정답제목
      state.questionform.ans7_text = ""; // 정답
      state.questionform.ans7_sub = ""; // 정답

      state.questionform.ans8 = ""; // 정답제목
      state.questionform.ans8_text = ""; // 정답
      state.questionform.ans8_sub = ""; // 정답

      state.questionform.ans9 = ""; // 정답제목
      state.questionform.ans9_text = ""; // 정답
      state.questionform.ans9_sub = ""; // 정답

      state.questionform.ans10 = ""; // 정답제목
      state.questionform.ans10_text = ""; // 정답
      state.questionform.ans10_sub = ""; // 정답

      state.questionform.image = ""; // 이미지
      state.questionform.videos = [
        {
          id: "video_1",
          link: "",
          video_from: "",
          video_to: "",
          video_use: true,
        },
      ]; // 동영상리스트
      state.questionform.sound = ""; // 사운드
      state.questionform.level = []; //난이도
      state.questionform.senlevel = ""; //난이도
      state.questionform.word_level = "";

      state.qtype1_answers = [];
      state.qtype2_picks = [];

      state.qtype3_picks = [];
      state.qtype5_picks = [];

      state.qtype7_picks = [];
      state.qtype8_picks = [];
      state.questionform.point = null;

      state.questionform.qcomment = null;
      state.questionform.qcomment_imsi = null;
    },
    resetQuestionMeta(state) {
      console.log("resetQuestionMeta");

      // state.questionmeta = {};

      // state.questionmeta.book_id = "";
      // state.questionmeta.qcode = "";  --> 좌측의 리스트화면에서 문제 클릭시에만 별도변경
      state.questionmeta.chapter = ""; //챕터
      state.questionmeta.unit = ""; // 유닛
      state.questionmeta.qserial = 0; // 문제순서.
      // state.questionmeta.std_type = "2"; //  학습유형
      state.questionmeta.statement = ""; //지시문(직독직해)
      state.questionmeta.statement2 = ""; //지시문(스크램블)
      state.questionmeta.statement3 = ""; //지시문(영작)
      state.questionmeta.statement4 = ""; //지시문(구조분석)
      state.questionmeta.id = "";
      state.questionmeta.jimun = ""; // 지문
      state.questionmeta.qcomment = ""; // 해설
      state.questionmeta.translate = ""; // 해석

      state.questionmeta.jimun_imsi = "REMOVED"; // 지문
      state.questionmeta.qcomment_imsi = ""; // 해설
      state.questionmeta.translate_imsi = ""; // 해석

      state.questionmeta.plain_jimun_imsi = "REMOVED"; // 원문
      state.questionmeta.plain_jimun = ""; // 원문

      // Vue.set(state.questionmeta, 'plain_jimun_imsi', "REMOVED");

      state.questionmeta.grp_type = "2";

      state.questionmeta.plain_jimun_subject = "";
      state.questionmeta.plain_jimun_level = "";

      state.questionmeta.jimunwords = [{ id: 1, word: "", comment: "" }];
    },

    loadBookForm(state, obj) {
      // let k = [];

      // obj.level = obj.target.split(",");
      console.log(obj);
      if (obj.target == null) {
        obj.target = [];
      } else {
        obj.target = obj.target.split(",");
      }

      state.bookform = obj;
    },

    //교재 관련 끝 ----------------------------------------

    //좌측  문제 리스트
    loadQuestionList(state, val) {
      state.questionlist = val;
    },

    //그룹문항의 메타정보에 묶여있는 질문리스트
    loadQuestionByMeta(state, val) {
      state.qforms = val;
    },

    //그룹문항의 메타정보에 묶여있는 질문리스트 클릭시콜
    loadQuestionByID(state, singleQ) {
      // let singleQ = question[0];

      state.questionform.ans1_text = "";
      state.questionform.ans2_text = "";
      state.questionform.ans3_text = "";
      state.questionform.ans4_text = "";
      state.questionform.ans5_text = "";
      state.questionform.ans6_text = "";
      state.questionform.ans7_text = "";
      state.questionform.ans8_text = "";
      state.questionform.ans9_text = "";
      state.questionform.ans10_tex;
      state.questionform.ans1 = "";
      state.questionform.ans2 = "";
      state.questionform.ans3 = "";
      state.questionform.ans4 = "";
      state.questionform.ans5 = "";
      state.questionform.ans6 = "";
      state.questionform.ans7 = "";
      state.questionform.ans8 = "";
      state.questionform.ans9 = "";
      state.questionform.ans10 = "";

      state.questionform.id = singleQ.id;
      state.questionform.meta_id = singleQ.meta_id;
      state.questionform.book_id = singleQ.book_id;
      state.questionform.q_type = singleQ.q_type;
      state.questionform.q_type_sub = singleQ.q_type_sub;
      state.questionform.title = singleQ.title;
      state.questionform.title_imsi = singleQ.title;
      state.questionform.sound = singleQ.sound;
      state.questionform.image = singleQ.image;
      state.questionform.word_level = singleQ.word_level;
      state.questionform.prevtest_info = singleQ.prevtest_info;
      state.questionform.qstatement = singleQ.qstatement;
      state.questionform.point = singleQ.point;

      if (singleQ.q_type === "1") {
        let qtype1_answers = [];

        for (let i = 1; i <= 10; i++) {
          console.log(singleQ[`ans${i}`]);
          if (
            singleQ[`ans${i}_text`] != "" &&
            singleQ[`ans${i}_text`] != null
          ) {
            let pick = {
              id: i,
              answer: singleQ[`ans${i}_text`],
              ansTitle: singleQ[`ans${i}`],
              intent: "",
            };

            state.questionform[`ans${i}_text`] = singleQ[`ans${i}_text`];
            qtype1_answers.push(pick);
          }
        }

        state.qtype1_answers = qtype1_answers;
        state.questionform.intent1 = JSON.parse(singleQ.intent1);

        try {
          state.questionform.intent2 = JSON.parse(singleQ.intent2);
        } catch (e) {
          console.log(e);
        }

        try {
          state.questionform.intent3 = JSON.parse(singleQ.intent3);
        } catch (e) {
          console.log(e);
        }
      } else if (singleQ.q_type === "2") {
        state.questionform.ans1 = singleQ.ans1;
        state.questionform.intent1 = JSON.parse(singleQ.intent1);
        try {
          state.questionform.intent2 = JSON.parse(singleQ.intent2);
        } catch (e) {
          console.log(e);
        }

        try {
          state.questionform.intent3 = JSON.parse(singleQ.intent3);
        } catch (e) {
          console.log(e);
        }

        let qtype2_picks = [];

        for (let i = 1; i <= 10; i++) {
          if (
            singleQ[`ans${i}_text`] != "" &&
            singleQ[`ans${i}_text`] != null
          ) {
            let pick = {
              id: i,
              text: singleQ[`ans${i}_text`],
              sub: singleQ[`ans${i}_sub`] == "1" ? true : false,
              myf: `updateAns${i}Text`,
            };
            state.questionform[`ans${i}_text`] = singleQ[`ans${i}_text`];
            qtype2_picks.push(pick);
          }
        }

        state.qtype2_picks = qtype2_picks;
      } else if (singleQ.q_type === "3" || singleQ.q_type === "6") {
        state.questionform.ans1 = singleQ.ans1;
        state.questionform.intent1 = JSON.parse(singleQ.intent1);

        try {
          state.questionform.intent2 = JSON.parse(singleQ.intent2);
        } catch (e) {
          console.log(e);
        }

        try {
          state.questionform.intent3 = JSON.parse(singleQ.intent3);
        } catch (e) {
          console.log(e);
        }

        let qtype3_picks = [];

        for (let i = 1; i <= 10; i++) {
          console.log(singleQ[`ans${i}`]);
          if (singleQ[`ans${i}`] != "" && singleQ[`ans${i}`] != null) {
            let pick = {
              id: i,
              text: singleQ[`ans${i}`],
              answer: singleQ[`ans${i}_text`],
              sub: singleQ[`ans${i}_sub`] == "1" ? true : false,
              myf1: `updateAns${i}`,
              myf2: `updateAns${i}Text`,
            };
            state.questionform[`ans${i}`] = singleQ[`ans${i}`];
            state.questionform[`ans${i}_text`] = singleQ[`ans${i}_text`];
            qtype3_picks.push(pick);
          }
        }

        state.qtype3_picks = qtype3_picks;
      } else if (singleQ.q_type === "4") {
        state.questionform.ans1 = singleQ.ans1;
        state.questionform.intent1 = JSON.parse(singleQ.intent1);

        try {
          state.questionform.intent2 = JSON.parse(singleQ.intent2);
        } catch (e) {
          console.log(e);
        }

        try {
          state.questionform.intent3 = JSON.parse(singleQ.intent3);
        } catch (e) {
          console.log(e);
        }
      } else if (singleQ.q_type === "5") {
        //state.questionform.ans1 = singleQ.ans1;
        state.questionform.intent1 = JSON.parse(singleQ.intent1);

        try {
          state.questionform.intent2 = JSON.parse(singleQ.intent2);
        } catch (e) {
          console.log(e);
        }

        try {
          state.questionform.intent3 = JSON.parse(singleQ.intent3);
        } catch (e) {
          console.log(e);
        }

        let qtype5_picks = [];

        for (let i = 1; i <= 10; i++) {
          if (singleQ[`ans${i}`] != "") {
            state.questionform[`ans${i}`] = singleQ[`ans${i}`];

            let pick = {
              id: i,
              text: singleQ[`ans${i}`],
              myf1: `updateAns${i}`,
              myf2: `updateAns${i}Text`,
            };
            qtype5_picks.push(pick);
          }
        }
        state.qtype5_picks = qtype5_picks;
      } else if (singleQ.q_type === "7") {
        state.questionform.intent1 = JSON.parse(singleQ.intent1);

        try {
          state.questionform.intent2 = JSON.parse(singleQ.intent2);
        } catch (e) {
          console.log(e);
        }

        try {
          state.questionform.intent3 = JSON.parse(singleQ.intent3);
        } catch (e) {
          console.log(e);
        }

        state.questionform.qcomment = singleQ.qcomment;
        state.questionform.qcomment_imsi = singleQ.qcomment;

        let qtype7_picks = [];

        for (let i = 1; i <= 10; i++) {
          if (singleQ[`ans${i}`] != "") {
            let pick = {
              id: i,
              text: singleQ[`ans${i}`],
              sub: singleQ[`ans${i}_sub`] == "1" ? true : false,
              myf1: `updateAns${i}`,
              myf2: `updateAns${i}Text`,
            };
            qtype7_picks.push(pick);

            state.questionform[`ans${i}`] = singleQ[`ans${i}`];
            state.questionform[`ans${i}_text`] = singleQ[`ans${i}_text`];
          }
        }
        state.qtype7_picks = qtype7_picks;
      } else if (singleQ.q_type === "8") {
        state.questionform.intent1 = JSON.parse(singleQ.intent1);

        try {
          state.questionform.intent2 = JSON.parse(singleQ.intent2);
        } catch (e) {
          console.log(e);
        }

        try {
          state.questionform.intent3 = JSON.parse(singleQ.intent3);
        } catch (e) {
          console.log(e);
        }

        state.questionform.qcomment = singleQ.qcomment;
        state.questionform.qcomment_imsi = singleQ.qcomment;
        let qtype8_picks = [];

        for (let i = 1; i <= 10; i++) {
          // if (singleQ[`ans${i}`] != "") {
          if (singleQ[`ans${i}_text`] != "") {
            let pick = {
              id: i,
              text: singleQ[`ans${i}`],
              answer: singleQ[`ans${i}_text`],
              sub: singleQ[`ans${i}_sub`] == "1" ? true : false,
              myf1: `updateAns${i}`,
              myf2: `updateAns${i}Text`,
            };
            qtype8_picks.push(pick);

            state.questionform[`ans${i}`] = singleQ[`ans${i}`];
            state.questionform[`ans${i}_text`] = singleQ[`ans${i}_text`];
          }
        }
        state.qtype8_picks = qtype8_picks;
      }
      /*
      else if (singleQ.q_type == '6') {
        state.questionform.ans1 = singleQ.ans1;
        state.questionform.intent1 = JSON.parse(singleQ.intent1);
        try {
          state.questionform.intent2 = JSON.parse(singleQ.intent2);
        } catch (e) { console.log(e); }

        try {
          state.questionform.intent3 = JSON.parse(singleQ.intent3);
        } catch (e) { console.log(e); }


        let qtype6_picks = [];

        for (let i = 1; i <= 10; i++) {

          if (singleQ[`ans${i}_text`] != "" && singleQ[`ans${i}_text`] != null) {
            let pick = {
              id: i,
              text: singleQ[`ans${i}_text`],
              myf: `updateAns${i}Text`,
            }
            state.questionform[`ans${i}_text`] = singleQ[`ans${i}_text`];
            qtype6_picks.push(pick);
          }
        }


        state.qtype6_picks = qtype6_picks;
      }
      */

      //videos 를 생성하기
      // singleQ.videos
      if (singleQ.videos != null) {
        let changed_videos = R.map((item) => {
          item.id = "video_" + item.id;
          return item;
        }, singleQ.videos);
        state.questionform.videos = changed_videos;
      }

      //난이도 로드
      if (singleQ.level != "") {
        let _k = singleQ.level.split(",");
        state.questionform.level = _k;
      }
    },

    //문제 메타 시작 --------------------------------------

    updateGrpType(state, val) {
      state.questionmeta.grp_type = val;
    },

    updateChapter(state, val) {
      state.questionmeta.chapter = val;
    },
    updateUnit(state, val) {
      state.questionmeta.unit = val;
    },
    updateQSerial(state, val) {
      state.questionmeta.qserial = val + "";
    },
    updateStdType(state, val) {
      state.questionmeta.std_type = val;
    },
    updateStatement(state, val) {
      state.questionmeta.statement = val;
    },

    updateStatement2(state, val) {
      state.questionmeta.statement2 = val;
    },
    updateStatement3(state, val) {
      state.questionmeta.statement3 = val;
    },

    updateStatement4(state, val) {
      state.questionmeta.statement4 = val;
    },

    updateJimun(state, val) {
      state.questionmeta.jimun = val;
    },

    updatePlainJimun(state, val) {
      state.questionmeta.plain_jimun = val;
    },
    updatePlainJimunImsi(state, val) {
      state.questionmeta.plain_jimun_imsi = val;
    },

    updateQComment(state, val) {
      state.questionmeta.qcomment = val;
    },

    updateQReadingComment(state, val) {
      state.questionform.qcomment = val;
    },

    updateR(state, val) {
      // for testing
      state.r = val;
    },

    updateTranslate(state, val) {
      state.questionmeta.translate = val;
    },
    updateTranslateImsi(state, val) {
      state.questionmeta.translate_imsi = val;
    },

    updatePlainJimunSubject(state, val) {
      state.questionmeta.plain_jimun_subject = val;
    },

    updatePlainJimunLevel(state, val) {
      state.questionmeta.plain_jimun_level = val;
    },

    //문제 메타 끝   --------------------------------------
    //문제 폼 등록   --------------------------------------

    updatePoint(state, val) {
      state.questionform.point = val;
    },

    updateQType(state, val) {
      state.questionform.q_type = val;
    },
    updateQTypeSub(state, val) {
      state.questionform.q_type_sub = val;
    },

    updateQTitle(state, val) {
      state.questionform.title = val;
    },

    updateAns1(state, val) {
      console.log("call updateAns1");
      state.questionform.ans1 = val;
    },
    updateAns1Text(state, val) {
      state.questionform.ans1_text = val;
    },
    updateIntent1(state, val) {
      state.questionform.intent1 = val;
    },

    updateAns2(state, val) {
      state.questionform.ans2 = val;
    },
    updateAns2Text(state, val) {
      state.questionform.ans2_text = val;
    },
    updateIntent2(state, val) {
      state.questionform.intent2 = val;
    },

    updateAns3(state, val) {
      state.questionform.ans3 = val;
    },
    updateAns3Text(state, val) {
      state.questionform.ans3_text = val;
    },
    updateIntent3(state, val) {
      state.questionform.intent3 = val;
    },

    updateAns4(state, val) {
      state.questionform.ans4 = val;
    },
    updateAns4Text(state, val) {
      state.questionform.ans4_text = val;
    },
    updateIntent4(state, val) {
      state.questionform.intent4 = val;
    },

    updateAns5(state, val) {
      state.questionform.ans5 = val;
    },
    updateAns5Text(state, val) {
      state.questionform.ans5_text = val;
    },
    updateIntent5(state, val) {
      state.questionform.intent5 = val;
    },

    updateAns6(state, val) {
      state.questionform.ans6 = val;
    },
    updateAns6Text(state, val) {
      state.questionform.ans6_text = val;
    },
    updateIntent6(state, val) {
      state.questionform.intent6 = val;
    },

    updateAns7(state, val) {
      state.questionform.ans7 = val;
    },
    updateAns7Text(state, val) {
      state.questionform.ans7_text = val;
    },
    updateIntent7(state, val) {
      state.questionform.intent7 = val;
    },

    updateAns8(state, val) {
      state.questionform.ans8 = val;
    },
    updateAns8Text(state, val) {
      state.questionform.ans8_text = val;
    },
    updateIntent8(state, val) {
      state.questionform.intent8 = val;
    },

    updateAns9(state, val) {
      state.questionform.ans9 = val;
    },
    updateAns9Text(state, val) {
      state.questionform.ans9_text = val;
    },
    updateIntent9(state, val) {
      state.questionform.intent9 = val;
    },

    updateAns10(state, val) {
      state.questionform.ans10 = val;
    },
    updateAns10Text(state, val) {
      state.questionform.ans10_text = val;
    },
    updateIntent10(state, val) {
      state.questionform.intent10 = val;
    },

    updateImage(state, val) {
      state.questionform.image = val;
    },
    updateSound(state, val) {
      state.questionform.sound = val;
    },
    updateLevel(state, val) {
      state.questionform.level = val;
    },
    updateSenLevel(state, val) {
      state.questionform.senlevel = val;
    },

    updateWordLevel(state, val) {
      state.questionform.word_level = val;
    },
    updatePrevtestInfo(state, val) {
      state.questionform.prevtest_info = val;
    },
    updateVideos(state, val) {
      state.questionform.videos = val;
    },

    updateQStatement(state, val) {
      state.questionform.qstatement = val;
    },

    //문제 폼  끝   --------------------------------------
    updateIntent(state, val) {
      state.intent_value = val;
    },
  },
  actions: {
    updateTotalQCountByID(context, userid) {
      let url = `${SERVER_URL}/questioncountbyid/${userid}`;
      axios.get(url).then((resp) => {
        let data = resp.data;
        context.state.totalQcountByID = data.count;
      });
    },

    Login(context, payload) {
      let url = `${SERVER_URL}/login`;
      axios.get(url, payload).then((resp) => {
        let data = resp.data;
        // context.commit("updateQSerial", data.next);
      });
    },

    //addQ에 쓰임
    ResetForReady(context) {
      context.commit("resetQuestionForm");
      context.commit("resetvalid");
      context.state.questionform.q_type = "1";
      context.state.qforms = [];
      context.dispatch("getNextSerial");
      context.state.mode = "form";

      context.commit("senStore/MU_RESET_ANSWERS");

      context.commit("resetQuestionMeta");

      if (context.state.questionmeta.std_type === "3") {
        console.log("독해진입");
        context.state.questionform.q_type = "7";
      }
    },

    getcedubook(context, cedubook_id) {
      let url = `${SERVER_URL}/cedubook/${cedubook_id}`;
      axios.get(url).then((resp) => {
        let data = resp.data;
        // context.state.bookform.title = data.prdname;
        context.state.bookform.coverimg = `http://www.cedubook.com/adm/data/product/${data.prdimg_M1}`;
      });
    },

    getNextSerial(context) {
      let bookid = context.state.questionmeta.book_id;
      let url = `${SERVER_URL}/nextserial/${bookid}`;
      axios.get(url).then((resp) => {
        let data = resp.data;

        context.commit("updateQSerial", data.next);
      });
    },

    updateDebug(context, msg) {
      context.commit("updateDebug", msg);
    },
    loadBookList(context, page) {
      let url = `${SERVER_URL}/book?page=${page}`;
      axios.get(url).then((resp) => {
        let data = resp.data.rows;

        context.state.booklist = data;
      });
    },

    loadBookbyId(context, id) {
      let url = `${SERVER_URL}/book/${id}`;
      axios.get(url).then((resp) => {
        let data = resp.data;
        context.commit("loadBookForm", data);
      });
    },

    loadQuestionList(context, book_id) {
      let srhtext = context.state.srhtext;
      let url = `${SERVER_URL}/question?book_id=${book_id}&title=${srhtext}&page=${context.state.currentPage}`;
      axios.get(url).then((resp) => {
        let data = resp.data;
        let total = data.count;
        context.commit("updateDebug", total);
        let startWith = total - (context.state.currentPage - 1) * 10;
        let mapIDX = R.addIndex(R.map);
        let rows = mapIDX((item, idx) => {
          item.rnum = startWith - idx;
          item.is_forpay_tf = item.is_forpay == 1 ? true : false;
          // item.is_forpay_tf = true;
          return item;
        }, data.rows);

        context.commit("loadQuestionList", rows);
        context.commit("updateCount", data.count);
      });
    },

    loadQuestionByMeta(context, meta_id) {
      let url = `${SERVER_URL}/questionlistByMetaID/${meta_id}`;

      axios.get(url).then((resp) => {
        let data = resp.data;
        context.commit("loadQuestionByMeta", data); // 그룹문항의 경우 등록시 메타대비 리스트
      });
    },

    loadQuestionByID(context, question_id) {
      let url = `${SERVER_URL}/questiononly/${question_id}`;

      axios.get(url).then((resp) => {
        let data = resp.data;

        context.commit("loadQuestionByID", data); // 그룹문항의 경우 등록시 메타대비 리스트
      });
    },

    updatepaymode(context, item) {
      let url = `${SERVER_URL}/updatepaymode/${item.id}`;
      axios.put(url, item).then((resp) => {
        // alert("페이로드 변경");
      });
    },

    loadQuestionFullByMeta(context, meta_id) {
      context.commit("resetvalid");
      let url = `${SERVER_URL}/question/${meta_id}`;
      axios.get(url).then((resp) => {
        let question = resp.data.question;
        let questionmeta = resp.data.questionmeta;

        context.state.previews_questions = question; // 미리보기용 그룹전체  문제 리스트
        context.commit("updateQuestionMeta", questionmeta);
        let std_type = questionmeta.std_type;

        if (std_type == "1") {
          // 문장풀이
          let singleQ = question[0];
          context.state.questionform.id = singleQ.id;
          context.state.questionform.meta_id = singleQ.meta_id;
          context.state.questionform.q_type = singleQ.q_type;
          context.state.questionform.q_type_sub = singleQ.q_type_sub;
          context.state.questionform.title = singleQ.title;
          context.state.questionform.title_imsi = singleQ.title;
          context.state.questionform.sound = singleQ.sound;
          context.state.questionform.image = singleQ.image;
          context.state.questionform.word_level = singleQ.word_level;
          context.state.questionform.prevtest_info = singleQ.prevtest_info;

          context.state.questionform.qstatement = singleQ.qstatement;

          let changed_videos = R.map((item) => {
            item.id = "video_" + item.id;
            return item;
          }, singleQ.videos);
          context.state.questionform.videos = changed_videos;

          // 난이도 로드
          if (singleQ.level != "") {
            let _k = singleQ.level.split(",");
            context.state.questionform.level = _k;
          }

          // alert(context.state.questionform.level);
          // context.state.questionform.senlevel = singleQ.level;

          context.commit("senStore/MU_UNIFIED_ANSWER_BIND", singleQ.senanswers);
        } else if (std_type == "2" || std_type == "3") {
          //문풀훈련
          let grp_type = questionmeta.grp_type;

          if (grp_type === "1") {
            //단일항목
            let singleQ = question[0];
            context.state.questionform.id = singleQ.id;
            context.state.questionform.meta_id = singleQ.meta_id;
            context.state.questionform.q_type = singleQ.q_type;
            context.state.questionform.q_type_sub = singleQ.q_type_sub;
            context.state.questionform.title = singleQ.title;
            context.state.questionform.title_imsi = singleQ.title;
            context.state.questionform.sound = singleQ.sound;
            context.state.questionform.image = singleQ.image;
            context.state.questionform.word_level = singleQ.word_level;
            context.state.questionform.prevtest_info = singleQ.prevtest_info;

            context.state.questionform.qstatement = singleQ.qstatement;

            if (singleQ.q_type === "1") {
              // qtype1_answers를 생성해야함.
              let qtype1_answers = [];

              for (let i = 1; i <= 10; i++) {
                console.log(singleQ[`ans${i}`]);
                if (
                  singleQ[`ans${i}_text`] != "" &&
                  singleQ[`ans${i}_text`] != null
                ) {
                  let pick = {
                    id: i,
                    answer: singleQ[`ans${i}_text`],
                    ansTitle: singleQ[`ans${i}`],
                    intent: "",
                  };

                  context.state.questionform[`ans${i}_text`] =
                    singleQ[`ans${i}_text`];
                  context.state.questionform[`ans${i}`] = singleQ[`ans${i}`];

                  qtype1_answers.push(pick);
                }
              }

              context.state.questionform.intent1 = JSON.parse(singleQ.intent1);
              // context.state.questionform.intent2 = JSON.parse(singleQ.intent2);
              // context.state.questionform.intent3 = JSON.parse(singleQ.intent3);

              try {
                context.state.questionform.intent2 = JSON.parse(
                  singleQ.intent2
                );
              } catch (e) {
                console.log(e);
              }

              try {
                context.state.questionform.intent3 = JSON.parse(
                  singleQ.intent3
                );
              } catch (e) {
                console.log(e);
              }

              context.state.qtype1_answers = qtype1_answers;
            } else if (singleQ.q_type === "2") {
              context.state.questionform.ans1 = singleQ.ans1;
              context.state.questionform.intent1 = JSON.parse(singleQ.intent1);
              // context.state.questionform.intent2 = JSON.parse(singleQ.intent2);
              // context.state.questionform.intent3 = JSON.parse(singleQ.intent3);

              try {
                context.state.questionform.intent2 = JSON.parse(
                  singleQ.intent2
                );
              } catch (e) {
                console.log(e);
              }

              try {
                context.state.questionform.intent3 = JSON.parse(
                  singleQ.intent3
                );
              } catch (e) {
                console.log(e);
              }

              let qtype2_picks = [];

              for (let i = 1; i <= 10; i++) {
                console.log(singleQ[`ans${i}`]);
                if (
                  singleQ[`ans${i}_text`] != "" &&
                  singleQ[`ans${i}_text`] != null
                ) {
                  let pick = {
                    id: i,
                    text: singleQ[`ans${i}_text`],
                    sub: singleQ[`ans${i}_sub`] == "1" ? true : false,
                    myf: `updateAns${i}Text`,
                  };
                  context.state.questionform[`ans${i}_text`] =
                    singleQ[`ans${i}_text`];
                  qtype2_picks.push(pick);
                }
              }

              context.state.qtype2_picks = qtype2_picks;
            } else if (singleQ.q_type === "3") {
              context.state.questionform.ans1 = singleQ.ans1;
              context.state.questionform.intent1 = JSON.parse(singleQ.intent1);
              // context.state.questionform.intent2 = JSON.parse(singleQ.intent2);
              // context.state.questionform.intent3 = JSON.parse(singleQ.intent3);

              try {
                context.state.questionform.intent2 = JSON.parse(
                  singleQ.intent2
                );
              } catch (e) {
                console.log(e);
              }

              try {
                context.state.questionform.intent3 = JSON.parse(
                  singleQ.intent3
                );
              } catch (e) {
                console.log(e);
              }

              let qtype3_picks = [];

              for (let i = 1; i <= 10; i++) {
                console.log(singleQ[`ans${i}`]);
                if (singleQ[`ans${i}`] != "" && singleQ[`ans${i}`] != null) {
                  let pick = {
                    id: i,
                    text: singleQ[`ans${i}`],
                    answer: singleQ[`ans${i}_text`],
                    sub: singleQ[`ans${i}_sub`] == "1" ? true : false,
                    myf1: `updateAns${i}`,
                    myf2: `updateAns${i}Text`,
                  };
                  context.state.questionform[`ans${i}`] = singleQ[`ans${i}`];
                  context.state.questionform[`ans${i}_text`] =
                    singleQ[`ans${i}_text`];
                  qtype3_picks.push(pick);
                }
              }

              context.state.qtype3_picks = qtype3_picks;
            } else if (singleQ.q_type === "4") {
              context.state.questionform.ans1 = singleQ.ans1;
              context.state.questionform.intent1 = JSON.parse(singleQ.intent1);
              // context.state.questionform.intent2 = JSON.parse(singleQ.intent2);
              // context.state.questionform.intent3 = JSON.parse(singleQ.intent3);

              try {
                context.state.questionform.intent2 = JSON.parse(
                  singleQ.intent2
                );
              } catch (e) {
                console.log(e);
              }

              try {
                context.state.questionform.intent3 = JSON.parse(
                  singleQ.intent3
                );
              } catch (e) {
                console.log(e);
              }
            } else if (singleQ.q_type === "5") {
              context.state.questionform.intent1 = JSON.parse(singleQ.intent1);
              try {
                context.state.questionform.intent2 = JSON.parse(
                  singleQ.intent2
                );
              } catch (e) {
                console.log(e);
              }

              try {
                context.state.questionform.intent3 = JSON.parse(
                  singleQ.intent3
                );
              } catch (e) {
                console.log(e);
              }

              let qtype5_picks = [];

              for (let i = 1; i <= 10; i++) {
                if (singleQ[`ans${i}`] != "" && singleQ[`ans${i}`] != null) {
                  let pick = {
                    id: i,
                    text: singleQ[`ans${i}`],
                    myf1: `updateAns${i}`,
                    myf2: `updateAns${i}Text`,
                  };
                  context.state.questionform[`ans${i}`] = singleQ[`ans${i}`];
                  context.state.questionform[`ans${i}_text`] =
                    singleQ[`ans${i}_text`];

                  qtype5_picks.push(pick);
                }
              }

              context.state.qtype5_picks = qtype5_picks;
            }

            //videos 를 생성하기
            // singleQ.videos
            let changed_videos = R.map((item) => {
              item.id = "video_" + item.id;
              return item;
            }, singleQ.videos);
            context.state.questionform.videos = changed_videos;

            //난이도 로드
            if (singleQ.level != "") {
              let _k = singleQ.level.split(",");
              context.state.questionform.level = _k;
            }
          } else if (grp_type === "2") {
            // 그룹항목
            context.commit("resetQuestionOnly");
            context.dispatch("loadQuestionByMeta", meta_id);
            // let singleQ = question[0];
            // alert(singleQ.q_type);
            // context.dispatch("updateQType", singleQ.q_type);
            // context.dispatch("updateQTypeSub",)

            if (question.length > 0) {
              let singleQ = question[0];
              context.commit("updateQType", singleQ.q_type);
              context.commit("updateQTypeSub", singleQ.q_type_sub);
              // context.state.questionform.q_type = singleQ.q_type;
              // context.state.questionform.q_type_sub = singleQ.q_type_sub;
            }
          }
        }

        //만약 개인항목이라면
      });
    },

    postBook(context) {
      let url = `${SERVER_URL}/book`;

      context.state.bookform.target = context.state.bookform.target.join(",");
      if (context.state.bookform.id != "") {
        axios
          .put(`${url}/${context.state.bookform.id}`, context.state.bookform)
          .then((resp) => {
            alert("교재수정완료");
            context.commit("resetBookForm");
            router.push("/admin/book/list");
          });
      } else {
        axios.post(url, context.state.bookform).then((resp) => {
          alert("교재등록완료");
          context.commit("resetBookForm");
          router.push("/admin/book/list");
        });
      }
    },
    pullContent(context, contentid) {
      axios.get(`http://localhost:1323/content/${contentid}`).then((resp) => {
        let data = resp.data;

        context.state.content = data;
      });
    },
    appendAnswer(context) {
      let max_obj = R.reduce(
        R.maxBy((n) => parseInt(n.num)),
        { num: "0" },
        context.state.answers
      );
      let next_num = parseInt(max_obj.num) + 1;
      console.log(next_num);
      context.state.answers = R.append(
        {
          num: next_num,
          head: "",
          body: "",
        },
        context.state.answers
      );
    },

    appendQType1Answer(context, seltext) {
      let max_obj = R.reduce(
        R.maxBy((n) => parseInt(n.id)),
        { id: "0" },
        context.state.qtype1_answers
      );
      let next_num = parseInt(max_obj.id) + 1;

      context.state.qtype1_answers = R.append(
        {
          id: next_num,
          ansTitle: "",
          answer: seltext,
          intent: "",
        },
        context.state.qtype1_answers
      );
      let cidx = context.state.qtype1_answers.length;
      context.state.questionform[`ans${cidx}_text`] = seltext;
    },

    removeQType1Answer(context, item) {
      let addmap = R.addIndex(R.map);

      let pval = [
        context.state.questionform.ans1_text,
        context.state.questionform.ans2_text,
        context.state.questionform.ans3_text,
        context.state.questionform.ans4_text,
        context.state.questionform.ans5_text,
        context.state.questionform.ans6_text,
        context.state.questionform.ans7_text,
        context.state.questionform.ans8_text,
        context.state.questionform.ans9_text,
        context.state.questionform.ans10_text,
      ];

      let exclude_items = R.filter(
        (n) => n.id != item.id,
        context.state.qtype1_answers
      );

      exclude_items = addmap((n, idx) => {
        n.answer = pval[n.id - 1];
        n.id = "" + (idx + 1);
        return n;
      }, exclude_items);
      context.state.qtype1_answers = exclude_items;

      context.state.questionform.ans1_text = "";
      context.state.questionform.ans2_text = "";
      context.state.questionform.ans3_text = "";
      context.state.questionform.ans4_text = "";
      context.state.questionform.ans5_text = "";
      context.state.questionform.ans6_text = "";
      context.state.questionform.ans7_text = "";
      context.state.questionform.ans8_text = "";
      context.state.questionform.ans9_text = "";
      context.state.questionform.ans10_text = "";

      addmap((item, idx) => {
        context.state.questionform[`ans${idx + 1}_text`] = item.answer;
      }, exclude_items);
    },

    appendQType2Pick(context, seltext) {
      let max_obj = R.reduce(
        R.maxBy((n) => parseInt(n.id)),
        { id: "0" },
        context.state.qtype2_picks
      );
      let next_num = parseInt(max_obj.id) + 1;

      context.state.qtype2_picks = R.append(
        {
          id: next_num,
          text: seltext,
          sub: false,
          myf: `updateAns${next_num}Text`,
        },
        context.state.qtype2_picks
      );

      let cidx = context.state.qtype2_picks.length;
      context.state.questionform[`ans${cidx}_text`] = seltext;
    },
    removeQType2Pick(context, item) {
      let addmap = R.addIndex(R.map);
      let pval = [
        context.state.questionform.ans1_text,
        context.state.questionform.ans2_text,
        context.state.questionform.ans3_text,
        context.state.questionform.ans4_text,
        context.state.questionform.ans5_text,
        context.state.questionform.ans6_text,
        context.state.questionform.ans7_text,
        context.state.questionform.ans8_text,
        context.state.questionform.ans9_text,
        context.state.questionform.ans10_text,
      ];

      let exclude_items = R.filter(
        (n) => n.id != item.id,
        context.state.qtype2_picks
      );

      exclude_items = addmap((n, idx) => {
        n.text = pval[n.id - 1];
        n.id = "" + (idx + 1);

        return n;
      }, exclude_items);

      context.state.qtype2_picks = exclude_items;

      context.state.questionform.ans1_text = "";
      context.state.questionform.ans2_text = "";
      context.state.questionform.ans3_text = "";
      context.state.questionform.ans4_text = "";
      context.state.questionform.ans5_text = "";

      addmap((item, idx) => {
        context.state.questionform[`ans${idx + 1}_text`] = item.text;
      }, exclude_items);
    },

    appendQType5Pick(context, seltext) {
      let max_obj = R.reduce(
        R.maxBy((n) => parseInt(n.id)),
        { id: "0" },
        context.state.qtype5_picks
      );
      let next_num = parseInt(max_obj.id) + 1;

      context.state.qtype5_picks = R.append(
        {
          id: next_num,
          text: seltext,
          myf1: `updateAns${next_num}`,
          //myf2: `updateAns${next_num}Text`, //fixed by  0322
        },
        context.state.qtype5_picks
      );
      let cidx = context.state.qtype5_picks.length;
      context.state.questionform[`ans${cidx}`] = seltext;
    },
    removeQType5Pick(context, item) {
      let addmap = R.addIndex(R.map);

      let pval = [
        context.state.questionform.ans1_text,
        context.state.questionform.ans2_text,
        context.state.questionform.ans3_text,
        context.state.questionform.ans4_text,
        context.state.questionform.ans5_text,
        context.state.questionform.ans6_text,
        context.state.questionform.ans7_text,
        context.state.questionform.ans8_text,
        context.state.questionform.ans9_text,
        context.state.questionform.ans10_text,
      ];
      let pvalonly = [
        context.state.questionform.ans1,
        context.state.questionform.ans2,
        context.state.questionform.ans3,
        context.state.questionform.ans4,
        context.state.questionform.ans5,
        context.state.questionform.ans6,
        context.state.questionform.ans7,
        context.state.questionform.ans8,
        context.state.questionform.ans9,
        context.state.questionform.ans10,
      ];
      let exclude_items = R.filter(
        (n) => n.id != item.id,
        context.state.qtype5_picks
      );

      exclude_items = addmap((n, idx) => {
        n.text = pvalonly[n.id - 1];
        n.answer = pval[n.id - 1];
        n.id = "" + (idx + 1);

        return n;
      }, exclude_items);

      console.log(exclude_items);

      context.state.qtype5_picks = exclude_items;

      context.state.questionform.ans1_text = "";
      context.state.questionform.ans2_text = "";
      context.state.questionform.ans3_text = "";
      context.state.questionform.ans4_text = "";
      context.state.questionform.ans5_text = "";
      context.state.questionform.ans6_text = "";
      context.state.questionform.ans7_text = "";
      context.state.questionform.ans8_text = "";
      context.state.questionform.ans9_text = "";
      context.state.questionform.ans10_text = "";

      context.state.questionform.ans1 = "";
      context.state.questionform.ans2 = "";
      context.state.questionform.ans3 = "";
      context.state.questionform.ans4 = "";
      context.state.questionform.ans5 = "";
      context.state.questionform.ans6 = "";
      context.state.questionform.ans7 = "";
      context.state.questionform.ans8 = "";
      context.state.questionform.ans9 = "";
      context.state.questionform.ans10 = "";

      addmap((item, idx) => {
        context.state.questionform[`ans${idx + 1}`] = item.text;
        context.state.questionform[`ans${idx + 1}_text`] = item.answer;
      }, exclude_items);
    },

    appendQType7Pick(context, seltext) {
      let max_obj = R.reduce(
        R.maxBy((n) => parseInt(n.id)),
        { id: "0" },
        context.state.qtype7_picks
      );
      let next_num = parseInt(max_obj.id) + 1;

      context.state.qtype7_picks = R.append(
        {
          id: next_num,
          text: seltext,
          answer: "",
          sub: false,
          myf1: `updateAns${next_num}`,
          myf2: `updateAns${next_num}Text`,
        },
        context.state.qtype7_picks
      );
      let cidx = context.state.qtype7_picks.length;
      context.state.questionform[`ans${cidx}`] = seltext;
    },
    removeQType7Pick(context, item) {
      let addmap = R.addIndex(R.map);

      let pval = [
        context.state.questionform.ans1_text,
        context.state.questionform.ans2_text,
        context.state.questionform.ans3_text,
        context.state.questionform.ans4_text,
        context.state.questionform.ans5_text,
        context.state.questionform.ans6_text,
        context.state.questionform.ans7_text,
        context.state.questionform.ans8_text,
        context.state.questionform.ans9_text,
        context.state.questionform.ans10_text,
      ];
      let pvalonly = [
        context.state.questionform.ans1,
        context.state.questionform.ans2,
        context.state.questionform.ans3,
        context.state.questionform.ans4,
        context.state.questionform.ans5,
        context.state.questionform.ans6,
        context.state.questionform.ans7,
        context.state.questionform.ans8,
        context.state.questionform.ans9,
        context.state.questionform.ans10,
      ];
      let exclude_items = R.filter(
        (n) => n.id != item.id,
        context.state.qtype7_picks
      );

      exclude_items = addmap((n, idx) => {
        n.text = pvalonly[n.id - 1];
        n.answer = pval[n.id - 1];
        n.id = "" + (idx + 1);

        return n;
      }, exclude_items);

      console.log(exclude_items);

      context.state.qtype7_picks = exclude_items;

      context.state.questionform.ans1_text = "";
      context.state.questionform.ans2_text = "";
      context.state.questionform.ans3_text = "";
      context.state.questionform.ans4_text = "";
      context.state.questionform.ans5_text = "";
      context.state.questionform.ans6_text = "";
      context.state.questionform.ans7_text = "";
      context.state.questionform.ans8_text = "";
      context.state.questionform.ans9_text = "";
      context.state.questionform.ans10_text = "";

      context.state.questionform.ans1 = "";
      context.state.questionform.ans2 = "";
      context.state.questionform.ans3 = "";
      context.state.questionform.ans4 = "";
      context.state.questionform.ans5 = "";
      context.state.questionform.ans6 = "";
      context.state.questionform.ans7 = "";
      context.state.questionform.ans8 = "";
      context.state.questionform.ans9 = "";
      context.state.questionform.ans10 = "";

      addmap((item, idx) => {
        context.state.questionform[`ans${idx + 1}`] = item.text;
        context.state.questionform[`ans${idx + 1}_text`] = item.answer;
      }, exclude_items);
    },
    appendQType8Pick(context, seltext) {
      let max_obj = R.reduce(
        R.maxBy((n) => parseInt(n.id)),
        { id: "0" },
        context.state.qtype8_picks
      );
      let next_num = parseInt(max_obj.id) + 1;

      context.state.qtype8_picks = R.append(
        {
          id: next_num,
          text: seltext,
          answer: "",
          sub: false,
          myf1: `updateAns${next_num}`,
          myf2: `updateAns${next_num}Text`,
        },
        context.state.qtype8_picks
      );
      let cidx = context.state.qtype8_picks.length;
      context.state.questionform[`ans${cidx}`] = seltext;
    },
    removeQType8Pick(context, item) {
      let addmap = R.addIndex(R.map);

      let pval = [
        context.state.questionform.ans1_text,
        context.state.questionform.ans2_text,
        context.state.questionform.ans3_text,
        context.state.questionform.ans4_text,
        context.state.questionform.ans5_text,
        context.state.questionform.ans6_text,
        context.state.questionform.ans7_text,
        context.state.questionform.ans8_text,
        context.state.questionform.ans9_text,
        context.state.questionform.ans10_text,
      ];
      let pvalonly = [
        context.state.questionform.ans1,
        context.state.questionform.ans2,
        context.state.questionform.ans3,
        context.state.questionform.ans4,
        context.state.questionform.ans5,
        context.state.questionform.ans6,
        context.state.questionform.ans7,
        context.state.questionform.ans8,
        context.state.questionform.ans9,
        context.state.questionform.ans10,
      ];
      let exclude_items = R.filter(
        (n) => n.id != item.id,
        context.state.qtype8_picks
      );

      exclude_items = addmap((n, idx) => {
        n.text = pvalonly[n.id - 1];
        n.answer = pval[n.id - 1];
        n.id = "" + (idx + 1);

        return n;
      }, exclude_items);

      console.log(exclude_items);

      context.state.qtype8_picks = exclude_items;

      context.state.questionform.ans1_text = "";
      context.state.questionform.ans2_text = "";
      context.state.questionform.ans3_text = "";
      context.state.questionform.ans4_text = "";
      context.state.questionform.ans5_text = "";
      context.state.questionform.ans6_text = "";
      context.state.questionform.ans7_text = "";
      context.state.questionform.ans8_text = "";
      context.state.questionform.ans9_text = "";
      context.state.questionform.ans10_text = "";

      context.state.questionform.ans1 = "";
      context.state.questionform.ans2 = "";
      context.state.questionform.ans3 = "";
      context.state.questionform.ans4 = "";
      context.state.questionform.ans5 = "";
      context.state.questionform.ans6 = "";
      context.state.questionform.ans7 = "";
      context.state.questionform.ans8 = "";
      context.state.questionform.ans9 = "";
      context.state.questionform.ans10 = "";

      addmap((item, idx) => {
        context.state.questionform[`ans${idx + 1}`] = item.text;
        context.state.questionform[`ans${idx + 1}_text`] = item.answer;
      }, exclude_items);
    },

    appendQType3Pick(context, seltext) {
      let max_obj = R.reduce(
        R.maxBy((n) => parseInt(n.id)),
        { id: "0" },
        context.state.qtype3_picks
      );
      let next_num = parseInt(max_obj.id) + 1;
      context.state.qtype3_picks = R.append(
        {
          id: next_num,
          text: seltext,
          answer: "",
          sub: false,
          myf1: `updateAns${next_num}`,
          myf2: `updateAns${next_num}Text`,
        },
        context.state.qtype3_picks
      );
      let cidx = context.state.qtype3_picks.length;
      context.state.questionform[`ans${cidx}`] = seltext;
    },

    removeQType3Pick(context, item) {
      let addmap = R.addIndex(R.map);

      let pval = [
        context.state.questionform.ans1_text,
        context.state.questionform.ans2_text,
        context.state.questionform.ans3_text,
        context.state.questionform.ans4_text,
        context.state.questionform.ans5_text,
        context.state.questionform.ans6_text,
        context.state.questionform.ans7_text,
        context.state.questionform.ans8_text,
        context.state.questionform.ans9_text,
        context.state.questionform.ans10_text,
      ];
      let pvalonly = [
        context.state.questionform.ans1,
        context.state.questionform.ans2,
        context.state.questionform.ans3,
        context.state.questionform.ans4,
        context.state.questionform.ans5,
        context.state.questionform.ans6,
        context.state.questionform.ans7,
        context.state.questionform.ans8,
        context.state.questionform.ans9,
        context.state.questionform.ans10,
      ];
      let exclude_items = R.filter(
        (n) => n.id != item.id,
        context.state.qtype3_picks
      );

      exclude_items = addmap((n, idx) => {
        n.text = pvalonly[n.id - 1];
        n.answer = pval[n.id - 1];
        n.id = "" + (idx + 1);

        return n;
      }, exclude_items);

      console.log(exclude_items);

      context.state.qtype3_picks = exclude_items;

      context.state.questionform.ans1_text = "";
      context.state.questionform.ans2_text = "";
      context.state.questionform.ans3_text = "";
      context.state.questionform.ans4_text = "";
      context.state.questionform.ans5_text = "";
      context.state.questionform.ans6_text = "";
      context.state.questionform.ans7_text = "";
      context.state.questionform.ans8_text = "";
      context.state.questionform.ans9_text = "";
      context.state.questionform.ans10_text = "";

      context.state.questionform.ans1 = "";
      context.state.questionform.ans2 = "";
      context.state.questionform.ans3 = "";
      context.state.questionform.ans4 = "";
      context.state.questionform.ans5 = "";
      context.state.questionform.ans6 = "";
      context.state.questionform.ans7 = "";
      context.state.questionform.ans8 = "";
      context.state.questionform.ans9 = "";
      context.state.questionform.ans10 = "";

      addmap((item, idx) => {
        context.state.questionform[`ans${idx + 1}`] = item.text;
        context.state.questionform[`ans${idx + 1}_text`] = item.answer;
      }, exclude_items);
    },

    removeAnswer(context, item) {
      let i = 0;
      let exclude_items = R.filter(
        (n) => n.num != item.num,
        context.state.answers
      );

      exclude_items = R.map((n) => {
        n.num = "" + (i + 1);
        i++;

        return n;
      }, exclude_items);

      context.state.answers = exclude_items;
    },

    appendIntent(context) {
      context.state.questionform.intent1;
    },

    appendVideo(context) {
      let max_obj = R.reduce(
        R.maxBy((n) => parseInt(n.id.split("_")[1])),
        { id: "video_0" },
        context.state.questionform.videos
      );
      console.log(max_obj);
      let next_num = parseInt(max_obj.id.split("_")[1]) + 1;
      console.log(next_num);
      context.state.questionform.videos = R.append(
        {
          id: "video_" + next_num,
          link: "",
          video_from: "",
          video_to: "",
          video_use: 1,
        },
        context.state.questionform.videos
      );
    },
    removeVideo(context, item) {
      let i = 0;
      let exclude_items = R.filter(
        (n) => n.id != item.id,
        context.state.questionform.videos
      );

      exclude_items = R.map((n) => {
        n.id = "video_" + (i + 1);
        i++;

        return n;
      }, exclude_items);

      context.state.questionform.videos = exclude_items;
    },

    async saveQType1(context) {
      context.commit("Updateformvalid");
      let formvalid = context.state.formvalid;
      if (!formvalid) {
        return false;
      }
      // alert("xxxx");
      // alert(context.state.questionform.q_type);

      if (context.state.questionform.q_type === "1") {
        let i = 1;
        R.forEach((x) => {
          context.state.questionform[`ans${i}`] = x.ansTitle;
          // context.state.questionform[`ans${i}_text`] = x.answer;
          // context.state.questionform[`intent${i}`] = JSON.stringify(x.intent);
          i++;
        }, context.state.qtype1_answers);

        //todo: intent1에 통합 출제의도 추가가 필요
        context.state.questionform.intent1 = JSON.stringify(
          context.state.questionform.intent1
        );
        context.state.questionform.intent2 = JSON.stringify(
          context.state.questionform.intent2
        );
        context.state.questionform.intent3 = JSON.stringify(
          context.state.questionform.intent3
        );
      } else if (context.state.questionform.q_type === "2") {
        // QType2
        let i = 1;
        R.forEach((x) => {
          // context.state.questionform[`ans${i}_text`] = x.text;
          context.state.questionform[`ans${i}_sub`] = x.sub;
          i++;
        }, context.state.qtype2_picks);

        context.state.questionform.intent1 = JSON.stringify(
          context.state.questionform.intent1
        );
        context.state.questionform.intent2 = JSON.stringify(
          context.state.questionform.intent2
        );
        context.state.questionform.intent3 = JSON.stringify(
          context.state.questionform.intent3
        );
      } else if (context.state.questionform.q_type === "3") {
        let i = 1;
        R.forEach((x) => {
          // context.state.questionform[`ans${i}`] = x.text;
          // context.state.questionform[`ans${i}_text`] = x.answer;
          context.state.questionform[`ans${i}_sub`] = x.sub;
          i++;
        }, context.state.qtype3_picks);
        context.state.questionform.intent1 = JSON.stringify(
          context.state.questionform.intent1
        );
        context.state.questionform.intent2 = JSON.stringify(
          context.state.questionform.intent2
        );
        context.state.questionform.intent3 = JSON.stringify(
          context.state.questionform.intent3
        );
      } else if (context.state.questionform.q_type === "4") {
        context.state.questionform.intent1 = JSON.stringify(
          context.state.questionform.intent1
        );
        context.state.questionform.intent2 = JSON.stringify(
          context.state.questionform.intent2
        );
        context.state.questionform.intent3 = JSON.stringify(
          context.state.questionform.intent3
        );
      } else if (context.state.questionform.q_type === "5") {
        context.state.questionform.intent1 = JSON.stringify(
          context.state.questionform.intent1
        );
        context.state.questionform.intent2 = JSON.stringify(
          context.state.questionform.intent2
        );
        context.state.questionform.intent3 = JSON.stringify(
          context.state.questionform.intent3
        );
      } else if (context.state.questionform.q_type === "6") {
        context.state.questionform.intent1 = JSON.stringify(
          context.state.questionform.intent1
        );
        context.state.questionform.intent2 = JSON.stringify(
          context.state.questionform.intent2
        );
        context.state.questionform.intent3 = JSON.stringify(
          context.state.questionform.intent3
        );
      }

      //  ans 시리즈를 변환시켜서  questionform에 입력함.(qtype1 의 경우)

      let book_id = context.state.book_id;
      context.state.questionform.book_id = book_id + "";
      context.state.questionmeta.book_id = book_id + "";

      let postobj = {
        questionform: context.state.questionform,
        questionmeta: context.state.questionmeta,
      };

      let url = `${SERVER_URL}/question`;
      if (context.state.questionform.id == "") {
        let url = `${SERVER_URL}/question`;
        return axios.post(url, postobj).then((resp) => {
          alert("문제등록완료");
          context.commit("updateDebug", context.state.questionform.intent1);
          context.commit("resetQuestionForm");
          context.commit("resetQuestionMeta");
          let book_id = context.state.book_id;
          context.dispatch("loadQuestionList", book_id);
          context.dispatch("getNextSerial");

          context.state.bookform.qcnt = context.state.bookform.qcnt + 1;
          return true;
        });
      } else {
        let url = `${SERVER_URL}/question/${context.state.questionform.id}`;
        return axios.put(url, postobj).then((resp) => {
          alert("문제수정완료");
          context.commit("resetQuestionForm");
          context.commit("resetQuestionMeta");
          let book_id = context.state.book_id;
          context.dispatch("loadQuestionList", book_id);
          return true;
        });
      }
    },

    /**  */
    addJimunVoca(context) {
      let vocas = context.state.questionmeta.jimunwords;
      console.log(context.state.questionmeta);

      let copy = _.cloneDeep(vocas);

      /** next_seq 처리  */
      let next_seq = _.sortBy(copy, ["id"])[copy.length - 1].id + 1;

      console.log(copy);
      copy.push({
        id: next_seq,
        word: null,
        comment: null,
      });

      context.state.questionmeta.jimunwords = copy;
    },
    removeJimunVoca(context, voca) {
      let vocas = context.state.questionmeta.jimunwords;
      let removedVocas = _.remove(vocas, function(n) {
        return n.id !== voca.id;
      });
      console.log(removedVocas);
      context.state.questionmeta.jimunwords = removedVocas;
    },

    saveorupdateQType1GroupMeta(context) {
      context.commit("updatemetavalid");
      let formvalid = context.state.formvalid;
      if (!formvalid) {
        return false;
      }
      let book_id = context.state.book_id;
      context.state.questionmeta.book_id = book_id;
      context.state.questionmeta.qserial =
        "" + context.state.questionmeta.qserial;
      let url = `${SERVER_URL}/questionmeta`;

      if (context.state.questionmeta.id == "") {
        context.state.bookform.qcnt = context.state.bookform.qcnt + 1;
      }
      context.state.questionmeta.book_id =
        context.state.questionmeta.book_id + "";

      return axios.post(url, context.state.questionmeta).then((resp) => {
        let data = resp.data;
        context.state.questionmeta.id = data.id;
        context.state.questionmeta.plain_jimun_idf = data.plain_jimun_idf;

        let book_id = context.state.book_id;
        context.dispatch("loadQuestionList", book_id);
        return true;
      });
    },

    async saveQType1GroupQuestionOnly(context) {
      //alert(context.state.questionform.q_type);
      context.commit("Updateformvalid");
      let formvalid = context.state.formvalid;
      if (!formvalid) {
        return false;
      }

      // meta_id를 가져와서 넘겨야함.
      let meta_id = context.state.questionmeta.id;
      //alert(context.state.questionform.q_type);
      // context.state.questionform.q_type  == 5

      /** todo: 비어있는 p 태그가 있는지 확인하는 곳 */
      //console.log(context.state);
      //console.log(context.state.qtype3_picks);
      //for(var i = 0 ;  i <  context.state.qtype3_picks.length ; i++){

      //}

      if (context.state.questionform.q_type === "1") {
        let i = 1;
        R.forEach((x) => {
          context.state.questionform[`ans${i}`] = x.ansTitle;
          // context.state.questionform[`ans${i}_text`] = x.answer;
          // context.state.questionform[`intent${i}`] = JSON.stringify(x.intent);
          i++;
        }, context.state.qtype1_answers);
        context.state.questionform.intent1 = JSON.stringify(
          context.state.questionform.intent1
        );
        context.state.questionform.intent2 = JSON.stringify(
          context.state.questionform.intent2
        );
        context.state.questionform.intent3 = JSON.stringify(
          context.state.questionform.intent3
        );
      } else if (context.state.questionform.q_type === "2") {
        // QType2
        let i = 1;
        R.forEach((x) => {
          // context.state.questionform[`ans${i}_text`] = x.text;
          context.state.questionform[`ans${i}_sub`] = x.sub;
          i++;
        }, context.state.qtype2_picks);

        context.state.questionform.intent1 = JSON.stringify(
          context.state.questionform.intent1
        );
        context.state.questionform.intent2 = JSON.stringify(
          context.state.questionform.intent2
        );
        context.state.questionform.intent3 = JSON.stringify(
          context.state.questionform.intent3
        );
      } else if (context.state.questionform.q_type === "3") {
        let i = 1;
        R.forEach((x) => {
          // context.state.questionform[`ans${i}`] = x.text;
          // context.state.questionform[`ans${i}_text`] = x.answer;
          context.state.questionform[`ans${i}_sub`] = x.sub;
          i++;
        }, context.state.qtype3_picks);

        context.state.questionform.intent1 = JSON.stringify(
          context.state.questionform.intent1
        );
        context.state.questionform.intent2 = JSON.stringify(
          context.state.questionform.intent2
        );
        context.state.questionform.intent3 = JSON.stringify(
          context.state.questionform.intent3
        );
      } else if (context.state.questionform.q_type === "4") {
        context.state.questionform.intent1 = JSON.stringify(
          context.state.questionform.intent1
        );
        context.state.questionform.intent2 = JSON.stringify(
          context.state.questionform.intent2
        );
        context.state.questionform.intent3 = JSON.stringify(
          context.state.questionform.intent3
        );
      } else if (context.state.questionform.q_type === "5") {
        console.log("qtype5_picks");
        console.log(context.state.qtype5_picks);

        // let i = 1;
        // R.forEach(x => {
        //   context.state.questionform[`ans${i}`] = x.text;
        //   i++;
        // }, context.state.qtype5_picks);

        context.state.questionform.intent1 = JSON.stringify(
          context.state.questionform.intent1
        );
        context.state.questionform.intent2 = JSON.stringify(
          context.state.questionform.intent2
        );
        context.state.questionform.intent3 = JSON.stringify(
          context.state.questionform.intent3
        );
      } else if (context.state.questionform.q_type === "6") {
        context.state.questionform.intent1 = JSON.stringify(
          context.state.questionform.intent1
        );
        context.state.questionform.intent2 = JSON.stringify(
          context.state.questionform.intent2
        );
        context.state.questionform.intent3 = JSON.stringify(
          context.state.questionform.intent3
        );
      } else if (context.state.questionform.q_type === "7") {
        console.log(context.state.qtype7_picks);

        context.state.questionform.intent1 = JSON.stringify(
          context.state.questionform.intent1
        );

        try {
          context.state.questionform.intent2 = JSON.stringify(
            context.state.questionform.intent2
          );
        } catch (e) {
          console.log("eeeor");
        }

        try {
          context.state.questionform.intent3 = JSON.stringify(
            context.state.questionform.intent3
          );
        } catch (e) {
          console.log("eeeor");
        }

        let i = 1;
        R.forEach((x) => {
          context.state.questionform[`ans${i}_sub`] = x.sub;
          // context.state.questionform[`ans${i}`] = x.text;
          i++;
        }, context.state.qtype7_picks);
      } else if (context.state.questionform.q_type === "8") {
        context.state.questionform.intent1 = JSON.stringify(
          context.state.questionform.intent1
        );

        try {
          context.state.questionform.intent2 = JSON.stringify(
            context.state.questionform.intent2
          );
        } catch (e) {
          console.log("eeeor");
        }

        try {
          context.state.questionform.intent3 = JSON.stringify(
            context.state.questionform.intent3
          );
        } catch (e) {
          console.log("eeeor");
        }

        let i = 1;
        R.forEach((x) => {
          context.state.questionform[`ans${i}_sub`] = x.sub;
          context.state.questionform[`ans${i}`] = x.text;
          // context.state.questionform[`ans${i}_text`] = x.answer;
          i++;
        }, context.state.qtype8_picks);

        console.log(context.state.qtype8_picks);
      }

      context.state.questionform.meta_id = meta_id;

      if (context.state.questionform.id != "") {
        let url = `${SERVER_URL}/questiononly/${context.state.questionform.id}`;

        return axios.put(url, context.state.questionform).then((resp) => {
          let data = resp.data;
          //그룹전용 리스트에 추가해야함.
          context.dispatch("loadQuestionByMeta", meta_id);
          return true;
        });
      } else {
        let url = `${SERVER_URL}/questiononly`;

        console.log(context.state.questionform);
        return axios.post(url, context.state.questionform).then((resp) => {
          let data = resp.data;
          //그룹전용 리스트에 추가해야함.
          context.dispatch("loadQuestionByMeta", meta_id);
          return true;
        });
      }
    },
    removeQuestionByID(context, questionid) {
      let url = `${SERVER_URL}/questiond/${questionid}`;

      let meta_id = context.state.questionmeta.id;
      axios.delete(url).then((resp) => {
        context.dispatch("loadQuestionByMeta", meta_id);
      });
    },
    removeQuestionFullByMeta(context, meta_id) {
      let url = `${SERVER_URL}/questionfull/${meta_id}`;

      axios.delete(url).then((resp) => {
        let book_id = context.state.book_id;
        context.dispatch("loadQuestionList", book_id);

        context.state.bookform.qcnt = context.state.bookform.qcnt - 1;
      });
    },
    loadIntent(context) {
      let url = `${SERVER_URL}/intent`;
      axios.get(url).then((resp) => {
        let _k = R.map((item) => {
          let _s = {
            d1: item.d1,
            d2: item.d2,
            d3: item.d3,
          };
          return _s;
        }, resp.data);
        context.state.intent_options = _k;
      });
    },
  },
  modules: {
    senStore: senStore,
    wriStore: wriStore,
    intentStore: intentStore,
    chapterStore: chapterStore,
  },
});
